import { render } from "./PartnersComponent.vue?vue&type=template&id=dc571f7a"
import script from "./PartnersComponent.vue?vue&type=script&lang=js"
export * from "./PartnersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__